import VideoInputControl from "./VideoInputControl";
import VideoInputTransformControl from "./VideoInputTransformControl";
import { useVideoBackgrounds } from "@platform/store";
import { VideoFiltersCpuUtilization } from "@core/features/video";
import { ContainerBreakpoints } from "../../videoMeeting.types";

export type Props = {
  containerBreakpoints: ContainerBreakpoints;
};

export function VideoMeetingControlsVideoInputContainer({
  containerBreakpoints,
}: Props) {
  const { cpuUtilization } = useVideoBackgrounds();

  const videoTransformsEnabled =
    cpuUtilization !== VideoFiltersCpuUtilization.Disabled;

  return videoTransformsEnabled ? (
    <VideoInputTransformControl containerBreakpoints={containerBreakpoints} />
  ) : (
    <VideoInputControl containerBreakpoints={containerBreakpoints} />
  );
}

export default VideoMeetingControlsVideoInputContainer;
